import z from "zod";

import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";

export const AuthorSchema = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1),
  position: z.string().min(1),
  photo: StrapiMediaSchema,
});

export type AuthorType = z.infer<typeof AuthorSchema>;
